export default __webpack_public_path__ + "static/media/person1.0ce6ccb3.png";